/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';

import {LocalizationComponent} from './localization.component';
import {LocalizationService} from './localization.service';
import {GPTranslateService} from './translate.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    LocalizationComponent
  ],
  exports: [
    LocalizationComponent
  ]
})
export class LocalizationModule {
  public static forRoot(): ModuleWithProviders<LocalizationModule> {
    return {
      ngModule: LocalizationModule,
      providers: [
        LocalizationService,
        GPTranslateService
      ]
    };
  }
}
